import React from 'react'
import range from 'lodash/range'
import styled from 'styled-components'

import StarIcon from '../../assets/svg/iconmonstr-star-3.svg'

const StarsLine = styled.div`

`

const Star = styled(StarIcon)`
  ${(props) => `
     fill: ${props.theme['$colors']['green']};
  `};
  width: 16px;
  height: 16px;
  margin-right: 4px;
  margin-bottom: 6px;
`

function Stars ({ value = 5 }) {
  return (
    <StarsLine>
      {range(Math.floor(value)).map(i => (
        <Star key={`star-${i}`}/>
      ))}
    </StarsLine>
  )
}

export default Stars
